var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0C38.0314 0 49 10.9686 49 24.5C49 38.0313 38.0314 49 24.5 49C20.7237 49.0056 17.001 48.1347 13.6237 46.4602C13.1957 46.2479 12.709 46.1782 12.2426 46.2817L3.06783 48.3188C1.63886 48.6361 0.364329 47.3612 0.681979 45.9323L2.72043 36.7628C2.82418 36.2961 2.75438 35.8091 2.54191 35.3808C0.865946 32.0023 -0.00565746 28.278 2.76334e-05 24.5C2.76334e-05 10.9686 10.9687 0 24.5 0ZM26.95 14.25C26.95 13.1454 26.0546 12.25 24.95 12.25H24.05C22.9454 12.25 22.05 13.1454 22.05 14.25V27.4C22.05 28.5046 22.9454 29.4 24.05 29.4H34.75C35.8546 29.4 36.75 28.5046 36.75 27.4V26.5C36.75 25.3954 35.8546 24.5 34.75 24.5H28.95C27.8454 24.5 26.95 23.6046 26.95 22.5V14.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTales);
export default __webpack_public_path__ + "static/media/tales.942e5c980113f7b698ea9798883c20a8.svg";
export { ForwardRef as ReactComponent };